import { render, staticRenderFns } from "./vendorPlan2.vue?vue&type=template&id=16866b67&"
import script from "./vendorPlan2.vue?vue&type=script&lang=js&"
export * from "./vendorPlan2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports